<template>
  <div class="pdf-app">
    <div class="onload-pdf" v-if="status" @click="onloadPdf">
      <div>点我下载</div>
      <span>本地下载查看</span>
    </div>
    <div v-else id="demo"></div>
  </div>
</template>

<script>
import Pdfh5 from 'pdfh5';
import 'pdfh5/css/pdfh5.css';
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

export default {
  data() {
    return {
      pdfurl: '',
      platform: '',
      pdfh5: null,
      status: false,
    };
  },
  mounted() {
    this.pdfh5 = null;
    const {pdfurl} = this.$route.query;
    this.pdfurl = pdfurl;
    this.pdfh5 = null;
    // 实例化
    if (pdfurl) {
      this.pdfh5 = new Pdfh5('#demo', {
        pdfurl,
      });
      // 监听完成事件
      this.pdfh5.on('complete', (status, msg, time) => {
        if (status !== 'success') {
          this.status = true;
          Toast.fail('预览失败 请尝试手动下载');
        }
      });
    }
  },

  methods: {
    onloadPdf() {
      window.open(this.pdfurl);
    },
  },

};
</script>

<style lang="scss">
.pdf-app {
  height: 100vh;
  width: 100%;
}
.onload-pdf {
  text-align: center;
  padding-top: 60px;
  color: #0066FF;
  font-size: 48px;
  span {
    color: #999;
    font-size: 28px;
  }
}
</style>
